import styled from 'styled-components';

import { hexToRgb, pxToRem } from '../../lib/utils';

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.layers.header};
  height: ${({ theme }) => pxToRem(theme.sizes.headerHeight)};
  background-color: ${({ theme }) => theme.colors.b};
  border-bottom: 1px solid ${({ theme }) => theme.colors.d};
  box-shadow: 0 5px 10px rgba(${({ theme }) => hexToRgb(theme.colors.a)}, 0.1);
`;
